import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import http from '@/utils/http.service';

type AccountingExportTransferOrderPayload = {
  officeIds: string[];
  doctorAttendingIds?: string[];
  from: Date;
  to: Date;
};
const exportTransferOrder = (payload: AccountingExportTransferOrderPayload) => {
  return http.accountings.exportTransferOrder(payload).then(({ data }) => {
    return data;
  });
};

const useAccountingExportTransferOrderMutation = (): UseMutationResult<
  Blob,
  Error,
  AccountingExportTransferOrderPayload
> => {
  const { t } = useTranslation();
  return useMutation({
    mutationFn: exportTransferOrder,
    onSuccess() {
      toast.success(t('http.accounting-export-transfer-order.success'));
    },
  });
};

export default useAccountingExportTransferOrderMutation;
